<div [class]="getClass()">
  <button
    mat-flat-button
    (click)="openPicker()"
    #colorPickerButton
    class="color-picker__button"
    aria-label="open color picker"
    i18n-aria-label="@@core.color-picker.open-picker">
    <span class="color-picker__toggle"
      [class.color-picker__toggle--as-line]="toggleFormat === 'line'"
      [class.color-picker__toggle--as-text]="toggleFormat === 'text'"
      [class.color-picker__toggle--as-polygon]="toggleFormat === 'polygon'"
      [class.color-picker__color-transparent]="!color"
      [style.backgroundColor]="color"
      mat-icon-button>
      @if (toggleFormat === 'text') {
        <mat-icon [style.color]="color">format_size</mat-icon>
      }
      @if (toggleFormat === 'line') {
        <span [style.backgroundColor]="color"></span>
      }
    </span>
    <mat-icon svgIcon="chevron_bottom" class="color-picker__chevron"></mat-icon>
  </button>
</div>

<ng-template #colorPickerContent>
  <div class="color-picker__picker mat-elevation-z4">

    <div class="color-picker__colors">

      @for (pickerColor of getPickerColors(); track pickerColor) {
        <button
          class="color-picker__color"
          (click)="selectColor(pickerColor)"
          (touchend)="selectColor(pickerColor)"
          [style.backgroundColor]="pickerColor"
          [aria-label]="getColorLabel(pickerColor)"
          [class.color-picker__color-transparent]="!pickerColor"
        [class.mat-elevation-z4]="pickerColor === color"></button>
      }
    </div>

    <div class="form-field-wrap">

      <mat-form-field appearance="outline" color="primary" subscriptSizing="fixed">
        <mat-label i18n="@@shared.color-picker.color-code">Color code</mat-label>
        <input matInput [formControl]="formControl">
        @if (hasError() && isRequired()) {
          <mat-error i18n="@@shared.color-picker.color-required">Color is required</mat-error>
        }
        @if (hasInvalidColorError()) {
          <mat-error>
            {{ getInvalidColorMessage() }}
          </mat-error>
        }
        <div matSuffix>
          <button mat-icon-button
                  tmTooltip="Copy"
                  i18n-tmTooltip="@@shared.color-picker.copy"
                  (click)="copyToClipboard()">
            <mat-icon svgIcon="copy"></mat-icon>
          </button>
        </div>
      </mat-form-field>

    </div>

  </div>
</ng-template>
